/* tslint:disable */
/* eslint-disable */
// this is an auto generated file. This will be overwritten

import * as APITypes from "../API";
type GeneratedQuery<InputType, OutputType> = string & {
  __generatedQueryInput: InputType;
  __generatedQueryOutput: OutputType;
};

export const getUserProfile = /* GraphQL */ `query GetUserProfile($id: ID!) {
  getUserProfile(id: $id) {
    id
    email
    name
    image
    authProviderUserId
    preferences
    createdAt
    updatedAt
    deactivatedAt
    onboardingState
    is_subscribed
    credits
    credits_quota
    meeting_hours
    meeting_hours_quota
    scheduled_hours
    timezone
    language
    autoScheduleProxy
    notifications {
      liveActivity
      pmfSummary
      preBrief
      __typename
    }
    preBrief
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetUserProfileQueryVariables,
  APITypes.GetUserProfileQuery
>;
export const listUserProfiles = /* GraphQL */ `query ListUserProfiles(
  $filter: ModelUserProfileFilterInput
  $limit: Int
  $nextToken: String
) {
  listUserProfiles(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      email
      name
      image
      authProviderUserId
      preferences
      createdAt
      updatedAt
      deactivatedAt
      onboardingState
      is_subscribed
      credits
      credits_quota
      meeting_hours
      meeting_hours_quota
      scheduled_hours
      timezone
      language
      autoScheduleProxy
      preBrief
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListUserProfilesQueryVariables,
  APITypes.ListUserProfilesQuery
>;
export const userProfilesByEmail = /* GraphQL */ `query UserProfilesByEmail(
  $email: String!
  $sortDirection: ModelSortDirection
  $filter: ModelUserProfileFilterInput
  $limit: Int
  $nextToken: String
) {
  userProfilesByEmail(
    email: $email
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      email
      name
      image
      authProviderUserId
      preferences
      createdAt
      updatedAt
      deactivatedAt
      onboardingState
      is_subscribed
      credits
      credits_quota
      meeting_hours
      meeting_hours_quota
      scheduled_hours
      timezone
      language
      autoScheduleProxy
      preBrief
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.UserProfilesByEmailQueryVariables,
  APITypes.UserProfilesByEmailQuery
>;
export const userProfilesByAuthProviderUserId = /* GraphQL */ `query UserProfilesByAuthProviderUserId(
  $authProviderUserId: String!
  $sortDirection: ModelSortDirection
  $filter: ModelUserProfileFilterInput
  $limit: Int
  $nextToken: String
) {
  userProfilesByAuthProviderUserId(
    authProviderUserId: $authProviderUserId
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      email
      name
      image
      authProviderUserId
      preferences
      createdAt
      updatedAt
      deactivatedAt
      onboardingState
      is_subscribed
      credits
      credits_quota
      meeting_hours
      meeting_hours_quota
      scheduled_hours
      timezone
      language
      autoScheduleProxy
      preBrief
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.UserProfilesByAuthProviderUserIdQueryVariables,
  APITypes.UserProfilesByAuthProviderUserIdQuery
>;
export const getProxy = /* GraphQL */ `query GetProxy($id: ID!) {
  getProxy(id: $id) {
    id
    userProfileId
    name
    metadata
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<APITypes.GetProxyQueryVariables, APITypes.GetProxyQuery>;
export const listProxies = /* GraphQL */ `query ListProxies(
  $filter: ModelProxyFilterInput
  $limit: Int
  $nextToken: String
) {
  listProxies(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      userProfileId
      name
      metadata
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListProxiesQueryVariables,
  APITypes.ListProxiesQuery
>;
export const proxiesByUserProfileId = /* GraphQL */ `query ProxiesByUserProfileId(
  $userProfileId: ID!
  $sortDirection: ModelSortDirection
  $filter: ModelProxyFilterInput
  $limit: Int
  $nextToken: String
) {
  proxiesByUserProfileId(
    userProfileId: $userProfileId
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      userProfileId
      name
      metadata
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ProxiesByUserProfileIdQueryVariables,
  APITypes.ProxiesByUserProfileIdQuery
>;
export const getPlugin = /* GraphQL */ `query GetPlugin($id: ID!) {
  getPlugin(id: $id) {
    id
    authProviderUserId
    userProfileId
    pluginType
    enabled
    pluginUserId
    calendars
    createdAt
    updatedAt
    config
    __typename
  }
}
` as GeneratedQuery<APITypes.GetPluginQueryVariables, APITypes.GetPluginQuery>;
export const listPlugins = /* GraphQL */ `query ListPlugins(
  $filter: ModelPluginFilterInput
  $limit: Int
  $nextToken: String
) {
  listPlugins(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      authProviderUserId
      userProfileId
      pluginType
      enabled
      pluginUserId
      calendars
      createdAt
      updatedAt
      config
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListPluginsQueryVariables,
  APITypes.ListPluginsQuery
>;
export const pluginsByUserProfileId = /* GraphQL */ `query PluginsByUserProfileId(
  $userProfileId: ID!
  $sortDirection: ModelSortDirection
  $filter: ModelPluginFilterInput
  $limit: Int
  $nextToken: String
) {
  pluginsByUserProfileId(
    userProfileId: $userProfileId
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      authProviderUserId
      userProfileId
      pluginType
      enabled
      pluginUserId
      calendars
      createdAt
      updatedAt
      config
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.PluginsByUserProfileIdQueryVariables,
  APITypes.PluginsByUserProfileIdQuery
>;
export const getDeviceToken = /* GraphQL */ `query GetDeviceToken($id: ID!) {
  getDeviceToken(id: $id) {
    id
    userProfileId
    authProviderUserId
    token
    platform
    deviceId
    deviceModelName
    deviceSystemVersion
    createdAt
    updatedAt
    lastUsedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetDeviceTokenQueryVariables,
  APITypes.GetDeviceTokenQuery
>;
export const listDeviceTokens = /* GraphQL */ `query ListDeviceTokens(
  $filter: ModelDeviceTokenFilterInput
  $limit: Int
  $nextToken: String
) {
  listDeviceTokens(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      userProfileId
      authProviderUserId
      token
      platform
      deviceId
      deviceModelName
      deviceSystemVersion
      createdAt
      updatedAt
      lastUsedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListDeviceTokensQueryVariables,
  APITypes.ListDeviceTokensQuery
>;
export const deviceTokensByUserProfileId = /* GraphQL */ `query DeviceTokensByUserProfileId(
  $userProfileId: ID!
  $sortDirection: ModelSortDirection
  $filter: ModelDeviceTokenFilterInput
  $limit: Int
  $nextToken: String
) {
  deviceTokensByUserProfileId(
    userProfileId: $userProfileId
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      userProfileId
      authProviderUserId
      token
      platform
      deviceId
      deviceModelName
      deviceSystemVersion
      createdAt
      updatedAt
      lastUsedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.DeviceTokensByUserProfileIdQueryVariables,
  APITypes.DeviceTokensByUserProfileIdQuery
>;
export const deviceTokensByAuthProviderUserId = /* GraphQL */ `query DeviceTokensByAuthProviderUserId(
  $authProviderUserId: String!
  $sortDirection: ModelSortDirection
  $filter: ModelDeviceTokenFilterInput
  $limit: Int
  $nextToken: String
) {
  deviceTokensByAuthProviderUserId(
    authProviderUserId: $authProviderUserId
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      userProfileId
      authProviderUserId
      token
      platform
      deviceId
      deviceModelName
      deviceSystemVersion
      createdAt
      updatedAt
      lastUsedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.DeviceTokensByAuthProviderUserIdQueryVariables,
  APITypes.DeviceTokensByAuthProviderUserIdQuery
>;
export const deviceTokensByDeviceId = /* GraphQL */ `query DeviceTokensByDeviceId(
  $deviceId: String!
  $sortDirection: ModelSortDirection
  $filter: ModelDeviceTokenFilterInput
  $limit: Int
  $nextToken: String
) {
  deviceTokensByDeviceId(
    deviceId: $deviceId
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      userProfileId
      authProviderUserId
      token
      platform
      deviceId
      deviceModelName
      deviceSystemVersion
      createdAt
      updatedAt
      lastUsedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.DeviceTokensByDeviceIdQueryVariables,
  APITypes.DeviceTokensByDeviceIdQuery
>;
export const getMeeting = /* GraphQL */ `query GetMeeting($id: ID!) {
  getMeeting(id: $id) {
    id
    botId
    startTimeUtc
    endTimeUtc
    deduplicationKey
    meetingRawData
    proxyMeetingIds
    fullTranscription
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetMeetingQueryVariables,
  APITypes.GetMeetingQuery
>;
export const listMeetings = /* GraphQL */ `query ListMeetings(
  $filter: ModelMeetingFilterInput
  $limit: Int
  $nextToken: String
) {
  listMeetings(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      botId
      startTimeUtc
      endTimeUtc
      deduplicationKey
      meetingRawData
      proxyMeetingIds
      fullTranscription
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListMeetingsQueryVariables,
  APITypes.ListMeetingsQuery
>;
export const meetingsByBotId = /* GraphQL */ `query MeetingsByBotId(
  $botId: String!
  $sortDirection: ModelSortDirection
  $filter: ModelMeetingFilterInput
  $limit: Int
  $nextToken: String
) {
  meetingsByBotId(
    botId: $botId
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      botId
      startTimeUtc
      endTimeUtc
      deduplicationKey
      meetingRawData
      proxyMeetingIds
      fullTranscription
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.MeetingsByBotIdQueryVariables,
  APITypes.MeetingsByBotIdQuery
>;
export const meetingsByDeduplicationKey = /* GraphQL */ `query MeetingsByDeduplicationKey(
  $deduplicationKey: String!
  $sortDirection: ModelSortDirection
  $filter: ModelMeetingFilterInput
  $limit: Int
  $nextToken: String
) {
  meetingsByDeduplicationKey(
    deduplicationKey: $deduplicationKey
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      botId
      startTimeUtc
      endTimeUtc
      deduplicationKey
      meetingRawData
      proxyMeetingIds
      fullTranscription
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.MeetingsByDeduplicationKeyQueryVariables,
  APITypes.MeetingsByDeduplicationKeyQuery
>;
export const getProxyMeeting = /* GraphQL */ `query GetProxyMeeting($id: ID!) {
  getProxyMeeting(id: $id) {
    id
    userProfileId
    proxyId
    botId
    calendarEventId
    calendarEventICalUID
    calendarId
    projectIds
    startTimeUtc
    endTimeUtc
    meetingUrl
    deduplicationKey
    meetingRawData
    platform
    summaries
    themes
    observations
    status
    transcription {
      rawTranscript
      __typename
    }
    memories
    sessionUID
    userPreBrief
    chatSessionId
    aiSuggestions
    insights {
      id
      label
      type
      content
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetProxyMeetingQueryVariables,
  APITypes.GetProxyMeetingQuery
>;
export const listProxyMeetings = /* GraphQL */ `query ListProxyMeetings(
  $filter: ModelProxyMeetingFilterInput
  $limit: Int
  $nextToken: String
) {
  listProxyMeetings(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      userProfileId
      proxyId
      botId
      calendarEventId
      calendarEventICalUID
      calendarId
      projectIds
      startTimeUtc
      endTimeUtc
      meetingUrl
      deduplicationKey
      meetingRawData
      platform
      summaries
      themes
      observations
      status
      memories
      sessionUID
      userPreBrief
      chatSessionId
      aiSuggestions
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListProxyMeetingsQueryVariables,
  APITypes.ListProxyMeetingsQuery
>;
export const proxyMeetingsByUserProfileId = /* GraphQL */ `query ProxyMeetingsByUserProfileId(
  $userProfileId: ID!
  $sortDirection: ModelSortDirection
  $filter: ModelProxyMeetingFilterInput
  $limit: Int
  $nextToken: String
) {
  proxyMeetingsByUserProfileId(
    userProfileId: $userProfileId
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      userProfileId
      proxyId
      botId
      calendarEventId
      calendarEventICalUID
      calendarId
      projectIds
      startTimeUtc
      endTimeUtc
      meetingUrl
      deduplicationKey
      meetingRawData
      platform
      summaries
      themes
      observations
      status
      memories
      sessionUID
      userPreBrief
      chatSessionId
      aiSuggestions
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ProxyMeetingsByUserProfileIdQueryVariables,
  APITypes.ProxyMeetingsByUserProfileIdQuery
>;
export const proxyMeetingsByProxyId = /* GraphQL */ `query ProxyMeetingsByProxyId(
  $proxyId: ID!
  $sortDirection: ModelSortDirection
  $filter: ModelProxyMeetingFilterInput
  $limit: Int
  $nextToken: String
) {
  proxyMeetingsByProxyId(
    proxyId: $proxyId
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      userProfileId
      proxyId
      botId
      calendarEventId
      calendarEventICalUID
      calendarId
      projectIds
      startTimeUtc
      endTimeUtc
      meetingUrl
      deduplicationKey
      meetingRawData
      platform
      summaries
      themes
      observations
      status
      memories
      sessionUID
      userPreBrief
      chatSessionId
      aiSuggestions
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ProxyMeetingsByProxyIdQueryVariables,
  APITypes.ProxyMeetingsByProxyIdQuery
>;
export const proxyMeetingsByBotId = /* GraphQL */ `query ProxyMeetingsByBotId(
  $botId: String!
  $sortDirection: ModelSortDirection
  $filter: ModelProxyMeetingFilterInput
  $limit: Int
  $nextToken: String
) {
  proxyMeetingsByBotId(
    botId: $botId
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      userProfileId
      proxyId
      botId
      calendarEventId
      calendarEventICalUID
      calendarId
      projectIds
      startTimeUtc
      endTimeUtc
      meetingUrl
      deduplicationKey
      meetingRawData
      platform
      summaries
      themes
      observations
      status
      memories
      sessionUID
      userPreBrief
      chatSessionId
      aiSuggestions
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ProxyMeetingsByBotIdQueryVariables,
  APITypes.ProxyMeetingsByBotIdQuery
>;
export const proxyMeetingsByCalendarEventId = /* GraphQL */ `query ProxyMeetingsByCalendarEventId(
  $calendarEventId: String!
  $sortDirection: ModelSortDirection
  $filter: ModelProxyMeetingFilterInput
  $limit: Int
  $nextToken: String
) {
  proxyMeetingsByCalendarEventId(
    calendarEventId: $calendarEventId
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      userProfileId
      proxyId
      botId
      calendarEventId
      calendarEventICalUID
      calendarId
      projectIds
      startTimeUtc
      endTimeUtc
      meetingUrl
      deduplicationKey
      meetingRawData
      platform
      summaries
      themes
      observations
      status
      memories
      sessionUID
      userPreBrief
      chatSessionId
      aiSuggestions
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ProxyMeetingsByCalendarEventIdQueryVariables,
  APITypes.ProxyMeetingsByCalendarEventIdQuery
>;
export const proxyMeetingsByCalendarEventICalUID = /* GraphQL */ `query ProxyMeetingsByCalendarEventICalUID(
  $calendarEventICalUID: String!
  $sortDirection: ModelSortDirection
  $filter: ModelProxyMeetingFilterInput
  $limit: Int
  $nextToken: String
) {
  proxyMeetingsByCalendarEventICalUID(
    calendarEventICalUID: $calendarEventICalUID
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      userProfileId
      proxyId
      botId
      calendarEventId
      calendarEventICalUID
      calendarId
      projectIds
      startTimeUtc
      endTimeUtc
      meetingUrl
      deduplicationKey
      meetingRawData
      platform
      summaries
      themes
      observations
      status
      memories
      sessionUID
      userPreBrief
      chatSessionId
      aiSuggestions
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ProxyMeetingsByCalendarEventICalUIDQueryVariables,
  APITypes.ProxyMeetingsByCalendarEventICalUIDQuery
>;
export const proxyMeetingsByCalendarId = /* GraphQL */ `query ProxyMeetingsByCalendarId(
  $calendarId: String!
  $sortDirection: ModelSortDirection
  $filter: ModelProxyMeetingFilterInput
  $limit: Int
  $nextToken: String
) {
  proxyMeetingsByCalendarId(
    calendarId: $calendarId
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      userProfileId
      proxyId
      botId
      calendarEventId
      calendarEventICalUID
      calendarId
      projectIds
      startTimeUtc
      endTimeUtc
      meetingUrl
      deduplicationKey
      meetingRawData
      platform
      summaries
      themes
      observations
      status
      memories
      sessionUID
      userPreBrief
      chatSessionId
      aiSuggestions
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ProxyMeetingsByCalendarIdQueryVariables,
  APITypes.ProxyMeetingsByCalendarIdQuery
>;
export const proxyMeetingsByDeduplicationKey = /* GraphQL */ `query ProxyMeetingsByDeduplicationKey(
  $deduplicationKey: String!
  $sortDirection: ModelSortDirection
  $filter: ModelProxyMeetingFilterInput
  $limit: Int
  $nextToken: String
) {
  proxyMeetingsByDeduplicationKey(
    deduplicationKey: $deduplicationKey
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      userProfileId
      proxyId
      botId
      calendarEventId
      calendarEventICalUID
      calendarId
      projectIds
      startTimeUtc
      endTimeUtc
      meetingUrl
      deduplicationKey
      meetingRawData
      platform
      summaries
      themes
      observations
      status
      memories
      sessionUID
      userPreBrief
      chatSessionId
      aiSuggestions
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ProxyMeetingsByDeduplicationKeyQueryVariables,
  APITypes.ProxyMeetingsByDeduplicationKeyQuery
>;
export const getCalendarEvent = /* GraphQL */ `query GetCalendarEvent(
  $id: ID!
  $userProfileId: ID!
  $calendarId: String!
  $platform: String!
) {
  getCalendarEvent(
    id: $id
    userProfileId: $userProfileId
    calendarId: $calendarId
    platform: $platform
  ) {
    id
    uuid
    calendarId
    userProfileId
    platform
    proxyMeetingId
    proxyMeeting {
      id
      userProfileId
      proxyId
      botId
      calendarEventId
      calendarEventICalUID
      calendarId
      projectIds
      startTimeUtc
      endTimeUtc
      meetingUrl
      deduplicationKey
      meetingRawData
      platform
      summaries
      themes
      observations
      status
      memories
      sessionUID
      userPreBrief
      chatSessionId
      aiSuggestions
      createdAt
      updatedAt
      __typename
    }
    dateUtc
    projectIds
    recurringId
    iCalUid
    title
    botStatus {
      message
      statusCode
      subCode
      __typename
    }
    startTimeUtc
    endTimeUtc
    isCancelled
    shortDescription
    meetingUrl
    organizerEmail
    fullDescription
    responseStatus
    status
    descriptionContentType
    attendees
    platformSpecificData
    metadata
    preBriefState
    preBrief {
      id
      label
      type
      content
      __typename
    }
    location
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetCalendarEventQueryVariables,
  APITypes.GetCalendarEventQuery
>;
export const listCalendarEvents = /* GraphQL */ `query ListCalendarEvents(
  $id: ID
  $userProfileIdCalendarIdPlatform: ModelCalendarEventPrimaryCompositeKeyConditionInput
  $filter: ModelCalendarEventFilterInput
  $limit: Int
  $nextToken: String
  $sortDirection: ModelSortDirection
) {
  listCalendarEvents(
    id: $id
    userProfileIdCalendarIdPlatform: $userProfileIdCalendarIdPlatform
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    sortDirection: $sortDirection
  ) {
    items {
      id
      uuid
      calendarId
      userProfileId
      platform
      proxyMeetingId
      dateUtc
      projectIds
      recurringId
      iCalUid
      title
      startTimeUtc
      endTimeUtc
      isCancelled
      shortDescription
      meetingUrl
      organizerEmail
      fullDescription
      responseStatus
      status
      descriptionContentType
      attendees
      platformSpecificData
      metadata
      preBriefState
      location
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListCalendarEventsQueryVariables,
  APITypes.ListCalendarEventsQuery
>;
export const calendarEventsByUuid = /* GraphQL */ `query CalendarEventsByUuid(
  $uuid: ID!
  $sortDirection: ModelSortDirection
  $filter: ModelCalendarEventFilterInput
  $limit: Int
  $nextToken: String
) {
  calendarEventsByUuid(
    uuid: $uuid
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      uuid
      calendarId
      userProfileId
      platform
      proxyMeetingId
      dateUtc
      projectIds
      recurringId
      iCalUid
      title
      startTimeUtc
      endTimeUtc
      isCancelled
      shortDescription
      meetingUrl
      organizerEmail
      fullDescription
      responseStatus
      status
      descriptionContentType
      attendees
      platformSpecificData
      metadata
      preBriefState
      location
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.CalendarEventsByUuidQueryVariables,
  APITypes.CalendarEventsByUuidQuery
>;
export const calendarEventsByCalendarId = /* GraphQL */ `query CalendarEventsByCalendarId(
  $calendarId: String!
  $sortDirection: ModelSortDirection
  $filter: ModelCalendarEventFilterInput
  $limit: Int
  $nextToken: String
) {
  calendarEventsByCalendarId(
    calendarId: $calendarId
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      uuid
      calendarId
      userProfileId
      platform
      proxyMeetingId
      dateUtc
      projectIds
      recurringId
      iCalUid
      title
      startTimeUtc
      endTimeUtc
      isCancelled
      shortDescription
      meetingUrl
      organizerEmail
      fullDescription
      responseStatus
      status
      descriptionContentType
      attendees
      platformSpecificData
      metadata
      preBriefState
      location
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.CalendarEventsByCalendarIdQueryVariables,
  APITypes.CalendarEventsByCalendarIdQuery
>;
export const calendarEventsByUserProfileIdAndStartTimeUtc = /* GraphQL */ `query CalendarEventsByUserProfileIdAndStartTimeUtc(
  $userProfileId: ID!
  $startTimeUtc: ModelStringKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelCalendarEventFilterInput
  $limit: Int
  $nextToken: String
) {
  calendarEventsByUserProfileIdAndStartTimeUtc(
    userProfileId: $userProfileId
    startTimeUtc: $startTimeUtc
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      uuid
      calendarId
      userProfileId
      platform
      proxyMeetingId
      dateUtc
      projectIds
      recurringId
      iCalUid
      title
      startTimeUtc
      endTimeUtc
      isCancelled
      shortDescription
      meetingUrl
      organizerEmail
      fullDescription
      responseStatus
      status
      descriptionContentType
      attendees
      platformSpecificData
      metadata
      preBriefState
      location
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.CalendarEventsByUserProfileIdAndStartTimeUtcQueryVariables,
  APITypes.CalendarEventsByUserProfileIdAndStartTimeUtcQuery
>;
export const calendarEventsByUserProfileIdAndRecurringId = /* GraphQL */ `query CalendarEventsByUserProfileIdAndRecurringId(
  $userProfileId: ID!
  $recurringId: ModelStringKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelCalendarEventFilterInput
  $limit: Int
  $nextToken: String
) {
  calendarEventsByUserProfileIdAndRecurringId(
    userProfileId: $userProfileId
    recurringId: $recurringId
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      uuid
      calendarId
      userProfileId
      platform
      proxyMeetingId
      dateUtc
      projectIds
      recurringId
      iCalUid
      title
      startTimeUtc
      endTimeUtc
      isCancelled
      shortDescription
      meetingUrl
      organizerEmail
      fullDescription
      responseStatus
      status
      descriptionContentType
      attendees
      platformSpecificData
      metadata
      preBriefState
      location
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.CalendarEventsByUserProfileIdAndRecurringIdQueryVariables,
  APITypes.CalendarEventsByUserProfileIdAndRecurringIdQuery
>;
export const calendarEventsByPlatform = /* GraphQL */ `query CalendarEventsByPlatform(
  $platform: String!
  $sortDirection: ModelSortDirection
  $filter: ModelCalendarEventFilterInput
  $limit: Int
  $nextToken: String
) {
  calendarEventsByPlatform(
    platform: $platform
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      uuid
      calendarId
      userProfileId
      platform
      proxyMeetingId
      dateUtc
      projectIds
      recurringId
      iCalUid
      title
      startTimeUtc
      endTimeUtc
      isCancelled
      shortDescription
      meetingUrl
      organizerEmail
      fullDescription
      responseStatus
      status
      descriptionContentType
      attendees
      platformSpecificData
      metadata
      preBriefState
      location
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.CalendarEventsByPlatformQueryVariables,
  APITypes.CalendarEventsByPlatformQuery
>;
export const calendarEventsByProxyMeetingId = /* GraphQL */ `query CalendarEventsByProxyMeetingId(
  $proxyMeetingId: ID!
  $sortDirection: ModelSortDirection
  $filter: ModelCalendarEventFilterInput
  $limit: Int
  $nextToken: String
) {
  calendarEventsByProxyMeetingId(
    proxyMeetingId: $proxyMeetingId
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      uuid
      calendarId
      userProfileId
      platform
      proxyMeetingId
      dateUtc
      projectIds
      recurringId
      iCalUid
      title
      startTimeUtc
      endTimeUtc
      isCancelled
      shortDescription
      meetingUrl
      organizerEmail
      fullDescription
      responseStatus
      status
      descriptionContentType
      attendees
      platformSpecificData
      metadata
      preBriefState
      location
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.CalendarEventsByProxyMeetingIdQueryVariables,
  APITypes.CalendarEventsByProxyMeetingIdQuery
>;
export const calendarEventsByDateUtcAndStartTimeUtc = /* GraphQL */ `query CalendarEventsByDateUtcAndStartTimeUtc(
  $dateUtc: AWSDate!
  $startTimeUtc: ModelStringKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelCalendarEventFilterInput
  $limit: Int
  $nextToken: String
) {
  calendarEventsByDateUtcAndStartTimeUtc(
    dateUtc: $dateUtc
    startTimeUtc: $startTimeUtc
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      uuid
      calendarId
      userProfileId
      platform
      proxyMeetingId
      dateUtc
      projectIds
      recurringId
      iCalUid
      title
      startTimeUtc
      endTimeUtc
      isCancelled
      shortDescription
      meetingUrl
      organizerEmail
      fullDescription
      responseStatus
      status
      descriptionContentType
      attendees
      platformSpecificData
      metadata
      preBriefState
      location
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.CalendarEventsByDateUtcAndStartTimeUtcQueryVariables,
  APITypes.CalendarEventsByDateUtcAndStartTimeUtcQuery
>;
export const calendarEventsByRecurringIdAndStartTimeUtc = /* GraphQL */ `query CalendarEventsByRecurringIdAndStartTimeUtc(
  $recurringId: String!
  $startTimeUtc: ModelStringKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelCalendarEventFilterInput
  $limit: Int
  $nextToken: String
) {
  calendarEventsByRecurringIdAndStartTimeUtc(
    recurringId: $recurringId
    startTimeUtc: $startTimeUtc
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      uuid
      calendarId
      userProfileId
      platform
      proxyMeetingId
      dateUtc
      projectIds
      recurringId
      iCalUid
      title
      startTimeUtc
      endTimeUtc
      isCancelled
      shortDescription
      meetingUrl
      organizerEmail
      fullDescription
      responseStatus
      status
      descriptionContentType
      attendees
      platformSpecificData
      metadata
      preBriefState
      location
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.CalendarEventsByRecurringIdAndStartTimeUtcQueryVariables,
  APITypes.CalendarEventsByRecurringIdAndStartTimeUtcQuery
>;
export const getStream = /* GraphQL */ `query GetStream($id: ID!, $userProfileId: ID!) {
  getStream(id: $id, userProfileId: $userProfileId) {
    id
    userProfileId
    pluginIds
    pluginMetadata
    name
    description
    aiTitle
    aiDescription
    enabled
    color
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<APITypes.GetStreamQueryVariables, APITypes.GetStreamQuery>;
export const listStreams = /* GraphQL */ `query ListStreams(
  $id: ID
  $userProfileId: ModelIDKeyConditionInput
  $filter: ModelStreamFilterInput
  $limit: Int
  $nextToken: String
  $sortDirection: ModelSortDirection
) {
  listStreams(
    id: $id
    userProfileId: $userProfileId
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    sortDirection: $sortDirection
  ) {
    items {
      id
      userProfileId
      pluginIds
      pluginMetadata
      name
      description
      aiTitle
      aiDescription
      enabled
      color
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListStreamsQueryVariables,
  APITypes.ListStreamsQuery
>;
export const streamsByUserProfileIdAndCreatedAt = /* GraphQL */ `query StreamsByUserProfileIdAndCreatedAt(
  $userProfileId: ID!
  $createdAt: ModelIntKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelStreamFilterInput
  $limit: Int
  $nextToken: String
) {
  streamsByUserProfileIdAndCreatedAt(
    userProfileId: $userProfileId
    createdAt: $createdAt
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      userProfileId
      pluginIds
      pluginMetadata
      name
      description
      aiTitle
      aiDescription
      enabled
      color
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.StreamsByUserProfileIdAndCreatedAtQueryVariables,
  APITypes.StreamsByUserProfileIdAndCreatedAtQuery
>;
export const getProject = /* GraphQL */ `query GetProject($id: ID!) {
  getProject(id: $id) {
    id
    userProfileId
    proxyId
    streamId
    stream {
      id
      userProfileId
      pluginIds
      pluginMetadata
      name
      description
      aiTitle
      aiDescription
      enabled
      color
      createdAt
      updatedAt
      __typename
    }
    metadata
    name
    title
    aiTitle
    subtitle
    aiSubtitle
    description
    aiDescription
    aiCompletionCriteria
    userContext
    status
    state
    enabled
    color
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetProjectQueryVariables,
  APITypes.GetProjectQuery
>;
export const listProjects = /* GraphQL */ `query ListProjects(
  $id: ID
  $filter: ModelProjectFilterInput
  $limit: Int
  $nextToken: String
  $sortDirection: ModelSortDirection
) {
  listProjects(
    id: $id
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    sortDirection: $sortDirection
  ) {
    items {
      id
      userProfileId
      proxyId
      streamId
      metadata
      name
      title
      aiTitle
      subtitle
      aiSubtitle
      description
      aiDescription
      aiCompletionCriteria
      userContext
      status
      state
      enabled
      color
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListProjectsQueryVariables,
  APITypes.ListProjectsQuery
>;
export const projectsByUserProfileIdAndCreatedAt = /* GraphQL */ `query ProjectsByUserProfileIdAndCreatedAt(
  $userProfileId: ID!
  $createdAt: ModelIntKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelProjectFilterInput
  $limit: Int
  $nextToken: String
) {
  projectsByUserProfileIdAndCreatedAt(
    userProfileId: $userProfileId
    createdAt: $createdAt
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      userProfileId
      proxyId
      streamId
      metadata
      name
      title
      aiTitle
      subtitle
      aiSubtitle
      description
      aiDescription
      aiCompletionCriteria
      userContext
      status
      state
      enabled
      color
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ProjectsByUserProfileIdAndCreatedAtQueryVariables,
  APITypes.ProjectsByUserProfileIdAndCreatedAtQuery
>;
export const projectsByProxyId = /* GraphQL */ `query ProjectsByProxyId(
  $proxyId: ID!
  $sortDirection: ModelSortDirection
  $filter: ModelProjectFilterInput
  $limit: Int
  $nextToken: String
) {
  projectsByProxyId(
    proxyId: $proxyId
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      userProfileId
      proxyId
      streamId
      metadata
      name
      title
      aiTitle
      subtitle
      aiSubtitle
      description
      aiDescription
      aiCompletionCriteria
      userContext
      status
      state
      enabled
      color
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ProjectsByProxyIdQueryVariables,
  APITypes.ProjectsByProxyIdQuery
>;
export const projectsByStreamIdAndCreatedAt = /* GraphQL */ `query ProjectsByStreamIdAndCreatedAt(
  $streamId: ID!
  $createdAt: ModelIntKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelProjectFilterInput
  $limit: Int
  $nextToken: String
) {
  projectsByStreamIdAndCreatedAt(
    streamId: $streamId
    createdAt: $createdAt
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      userProfileId
      proxyId
      streamId
      metadata
      name
      title
      aiTitle
      subtitle
      aiSubtitle
      description
      aiDescription
      aiCompletionCriteria
      userContext
      status
      state
      enabled
      color
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ProjectsByStreamIdAndCreatedAtQueryVariables,
  APITypes.ProjectsByStreamIdAndCreatedAtQuery
>;
export const getDataAccess = /* GraphQL */ `query GetDataAccess($id: ID!, $projectId: ID!, $type: DataAccessType!) {
  getDataAccess(id: $id, projectId: $projectId, type: $type) {
    id
    userProfileId
    projectId
    pluginId
    sourceIds
    type
    metadata
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetDataAccessQueryVariables,
  APITypes.GetDataAccessQuery
>;
export const listDataAccesses = /* GraphQL */ `query ListDataAccesses(
  $id: ID
  $projectIdType: ModelDataAccessPrimaryCompositeKeyConditionInput
  $filter: ModelDataAccessFilterInput
  $limit: Int
  $nextToken: String
  $sortDirection: ModelSortDirection
) {
  listDataAccesses(
    id: $id
    projectIdType: $projectIdType
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    sortDirection: $sortDirection
  ) {
    items {
      id
      userProfileId
      projectId
      pluginId
      sourceIds
      type
      metadata
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListDataAccessesQueryVariables,
  APITypes.ListDataAccessesQuery
>;
export const dataAccessesByUserProfileIdAndCreatedAt = /* GraphQL */ `query DataAccessesByUserProfileIdAndCreatedAt(
  $userProfileId: ID!
  $createdAt: ModelIntKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelDataAccessFilterInput
  $limit: Int
  $nextToken: String
) {
  dataAccessesByUserProfileIdAndCreatedAt(
    userProfileId: $userProfileId
    createdAt: $createdAt
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      userProfileId
      projectId
      pluginId
      sourceIds
      type
      metadata
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.DataAccessesByUserProfileIdAndCreatedAtQueryVariables,
  APITypes.DataAccessesByUserProfileIdAndCreatedAtQuery
>;
export const dataAccessesByProjectIdAndTypeAndCreatedAt = /* GraphQL */ `query DataAccessesByProjectIdAndTypeAndCreatedAt(
  $projectId: ID!
  $typeCreatedAt: ModelDataAccessByProjectIdCompositeKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelDataAccessFilterInput
  $limit: Int
  $nextToken: String
) {
  dataAccessesByProjectIdAndTypeAndCreatedAt(
    projectId: $projectId
    typeCreatedAt: $typeCreatedAt
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      userProfileId
      projectId
      pluginId
      sourceIds
      type
      metadata
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.DataAccessesByProjectIdAndTypeAndCreatedAtQueryVariables,
  APITypes.DataAccessesByProjectIdAndTypeAndCreatedAtQuery
>;
export const dataAccessesByPluginId = /* GraphQL */ `query DataAccessesByPluginId(
  $pluginId: ID!
  $sortDirection: ModelSortDirection
  $filter: ModelDataAccessFilterInput
  $limit: Int
  $nextToken: String
) {
  dataAccessesByPluginId(
    pluginId: $pluginId
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      userProfileId
      projectId
      pluginId
      sourceIds
      type
      metadata
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.DataAccessesByPluginIdQueryVariables,
  APITypes.DataAccessesByPluginIdQuery
>;
export const getArtifact = /* GraphQL */ `query GetArtifact($id: ID!, $dataAccessId: ID!) {
  getArtifact(id: $id, dataAccessId: $dataAccessId) {
    id
    userProfileId
    projectId
    dataAccessId
    pluginId
    state
    pluginType
    name
    fileExtension
    s3Pointer
    aiContent
    aiReference
    aiReasoning
    sourceId
    aiMetadata
    enabled
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetArtifactQueryVariables,
  APITypes.GetArtifactQuery
>;
export const listArtifacts = /* GraphQL */ `query ListArtifacts(
  $id: ID
  $dataAccessId: ModelIDKeyConditionInput
  $filter: ModelArtifactFilterInput
  $limit: Int
  $nextToken: String
  $sortDirection: ModelSortDirection
) {
  listArtifacts(
    id: $id
    dataAccessId: $dataAccessId
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    sortDirection: $sortDirection
  ) {
    items {
      id
      userProfileId
      projectId
      dataAccessId
      pluginId
      state
      pluginType
      name
      fileExtension
      s3Pointer
      aiContent
      aiReference
      aiReasoning
      sourceId
      aiMetadata
      enabled
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListArtifactsQueryVariables,
  APITypes.ListArtifactsQuery
>;
export const artifactsByUserProfileId = /* GraphQL */ `query ArtifactsByUserProfileId(
  $userProfileId: ID!
  $sortDirection: ModelSortDirection
  $filter: ModelArtifactFilterInput
  $limit: Int
  $nextToken: String
) {
  artifactsByUserProfileId(
    userProfileId: $userProfileId
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      userProfileId
      projectId
      dataAccessId
      pluginId
      state
      pluginType
      name
      fileExtension
      s3Pointer
      aiContent
      aiReference
      aiReasoning
      sourceId
      aiMetadata
      enabled
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ArtifactsByUserProfileIdQueryVariables,
  APITypes.ArtifactsByUserProfileIdQuery
>;
export const artifactsByProjectId = /* GraphQL */ `query ArtifactsByProjectId(
  $projectId: ID!
  $sortDirection: ModelSortDirection
  $filter: ModelArtifactFilterInput
  $limit: Int
  $nextToken: String
) {
  artifactsByProjectId(
    projectId: $projectId
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      userProfileId
      projectId
      dataAccessId
      pluginId
      state
      pluginType
      name
      fileExtension
      s3Pointer
      aiContent
      aiReference
      aiReasoning
      sourceId
      aiMetadata
      enabled
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ArtifactsByProjectIdQueryVariables,
  APITypes.ArtifactsByProjectIdQuery
>;
export const artifactsByDataAccessId = /* GraphQL */ `query ArtifactsByDataAccessId(
  $dataAccessId: ID!
  $sortDirection: ModelSortDirection
  $filter: ModelArtifactFilterInput
  $limit: Int
  $nextToken: String
) {
  artifactsByDataAccessId(
    dataAccessId: $dataAccessId
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      userProfileId
      projectId
      dataAccessId
      pluginId
      state
      pluginType
      name
      fileExtension
      s3Pointer
      aiContent
      aiReference
      aiReasoning
      sourceId
      aiMetadata
      enabled
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ArtifactsByDataAccessIdQueryVariables,
  APITypes.ArtifactsByDataAccessIdQuery
>;
export const artifactsByPluginId = /* GraphQL */ `query ArtifactsByPluginId(
  $pluginId: ID!
  $sortDirection: ModelSortDirection
  $filter: ModelArtifactFilterInput
  $limit: Int
  $nextToken: String
) {
  artifactsByPluginId(
    pluginId: $pluginId
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      userProfileId
      projectId
      dataAccessId
      pluginId
      state
      pluginType
      name
      fileExtension
      s3Pointer
      aiContent
      aiReference
      aiReasoning
      sourceId
      aiMetadata
      enabled
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ArtifactsByPluginIdQueryVariables,
  APITypes.ArtifactsByPluginIdQuery
>;
export const artifactsByStateAndCreatedAt = /* GraphQL */ `query ArtifactsByStateAndCreatedAt(
  $state: ArtifactState!
  $createdAt: ModelIntKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelArtifactFilterInput
  $limit: Int
  $nextToken: String
) {
  artifactsByStateAndCreatedAt(
    state: $state
    createdAt: $createdAt
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      userProfileId
      projectId
      dataAccessId
      pluginId
      state
      pluginType
      name
      fileExtension
      s3Pointer
      aiContent
      aiReference
      aiReasoning
      sourceId
      aiMetadata
      enabled
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ArtifactsByStateAndCreatedAtQueryVariables,
  APITypes.ArtifactsByStateAndCreatedAtQuery
>;
export const getNote = /* GraphQL */ `query GetNote($id: ID!, $userProfileId: ID!) {
  getNote(id: $id, userProfileId: $userProfileId) {
    id
    userProfileId
    relatedType
    relatedId
    content
    title
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<APITypes.GetNoteQueryVariables, APITypes.GetNoteQuery>;
export const listNotes = /* GraphQL */ `query ListNotes(
  $id: ID
  $userProfileId: ModelIDKeyConditionInput
  $filter: ModelNoteFilterInput
  $limit: Int
  $nextToken: String
  $sortDirection: ModelSortDirection
) {
  listNotes(
    id: $id
    userProfileId: $userProfileId
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    sortDirection: $sortDirection
  ) {
    items {
      id
      userProfileId
      relatedType
      relatedId
      content
      title
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<APITypes.ListNotesQueryVariables, APITypes.ListNotesQuery>;
export const notesByUserProfileIdAndCreatedAt = /* GraphQL */ `query NotesByUserProfileIdAndCreatedAt(
  $userProfileId: ID!
  $createdAt: ModelIntKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelNoteFilterInput
  $limit: Int
  $nextToken: String
) {
  notesByUserProfileIdAndCreatedAt(
    userProfileId: $userProfileId
    createdAt: $createdAt
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      userProfileId
      relatedType
      relatedId
      content
      title
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.NotesByUserProfileIdAndCreatedAtQueryVariables,
  APITypes.NotesByUserProfileIdAndCreatedAtQuery
>;
export const notesByRelatedTypeAndCreatedAt = /* GraphQL */ `query NotesByRelatedTypeAndCreatedAt(
  $relatedType: String!
  $createdAt: ModelIntKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelNoteFilterInput
  $limit: Int
  $nextToken: String
) {
  notesByRelatedTypeAndCreatedAt(
    relatedType: $relatedType
    createdAt: $createdAt
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      userProfileId
      relatedType
      relatedId
      content
      title
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.NotesByRelatedTypeAndCreatedAtQueryVariables,
  APITypes.NotesByRelatedTypeAndCreatedAtQuery
>;
export const notesByRelatedIdAndUserProfileIdAndRelatedType = /* GraphQL */ `query NotesByRelatedIdAndUserProfileIdAndRelatedType(
  $relatedId: ID!
  $userProfileIdRelatedType: ModelNoteByRelatedIdCompositeKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelNoteFilterInput
  $limit: Int
  $nextToken: String
) {
  notesByRelatedIdAndUserProfileIdAndRelatedType(
    relatedId: $relatedId
    userProfileIdRelatedType: $userProfileIdRelatedType
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      userProfileId
      relatedType
      relatedId
      content
      title
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.NotesByRelatedIdAndUserProfileIdAndRelatedTypeQueryVariables,
  APITypes.NotesByRelatedIdAndUserProfileIdAndRelatedTypeQuery
>;
export const getConcept = /* GraphQL */ `query GetConcept($id: ID!, $userProfileId: ID!) {
  getConcept(id: $id, userProfileId: $userProfileId) {
    id
    userProfileId
    title
    type
    entries {
      nextToken
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetConceptQueryVariables,
  APITypes.GetConceptQuery
>;
export const listConcepts = /* GraphQL */ `query ListConcepts(
  $id: ID
  $userProfileId: ModelIDKeyConditionInput
  $filter: ModelConceptFilterInput
  $limit: Int
  $nextToken: String
  $sortDirection: ModelSortDirection
) {
  listConcepts(
    id: $id
    userProfileId: $userProfileId
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    sortDirection: $sortDirection
  ) {
    items {
      id
      userProfileId
      title
      type
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListConceptsQueryVariables,
  APITypes.ListConceptsQuery
>;
export const conceptsByUserProfileIdAndCreatedAt = /* GraphQL */ `query ConceptsByUserProfileIdAndCreatedAt(
  $userProfileId: ID!
  $createdAt: ModelIntKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelConceptFilterInput
  $limit: Int
  $nextToken: String
) {
  conceptsByUserProfileIdAndCreatedAt(
    userProfileId: $userProfileId
    createdAt: $createdAt
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      userProfileId
      title
      type
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ConceptsByUserProfileIdAndCreatedAtQueryVariables,
  APITypes.ConceptsByUserProfileIdAndCreatedAtQuery
>;
export const getConceptEntry = /* GraphQL */ `query GetConceptEntry($id: ID!, $conceptId: ID!) {
  getConceptEntry(id: $id, conceptId: $conceptId) {
    id
    userProfileId
    conceptId
    body
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetConceptEntryQueryVariables,
  APITypes.GetConceptEntryQuery
>;
export const listConceptEntries = /* GraphQL */ `query ListConceptEntries(
  $id: ID
  $conceptId: ModelIDKeyConditionInput
  $filter: ModelConceptEntryFilterInput
  $limit: Int
  $nextToken: String
  $sortDirection: ModelSortDirection
) {
  listConceptEntries(
    id: $id
    conceptId: $conceptId
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    sortDirection: $sortDirection
  ) {
    items {
      id
      userProfileId
      conceptId
      body
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListConceptEntriesQueryVariables,
  APITypes.ListConceptEntriesQuery
>;
export const conceptEntriesByUserProfileIdAndConceptId = /* GraphQL */ `query ConceptEntriesByUserProfileIdAndConceptId(
  $userProfileId: ID!
  $conceptId: ModelIDKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelConceptEntryFilterInput
  $limit: Int
  $nextToken: String
) {
  conceptEntriesByUserProfileIdAndConceptId(
    userProfileId: $userProfileId
    conceptId: $conceptId
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      userProfileId
      conceptId
      body
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ConceptEntriesByUserProfileIdAndConceptIdQueryVariables,
  APITypes.ConceptEntriesByUserProfileIdAndConceptIdQuery
>;
export const conceptEntriesByConceptIdAndCreatedAt = /* GraphQL */ `query ConceptEntriesByConceptIdAndCreatedAt(
  $conceptId: ID!
  $createdAt: ModelIntKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelConceptEntryFilterInput
  $limit: Int
  $nextToken: String
) {
  conceptEntriesByConceptIdAndCreatedAt(
    conceptId: $conceptId
    createdAt: $createdAt
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      userProfileId
      conceptId
      body
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ConceptEntriesByConceptIdAndCreatedAtQueryVariables,
  APITypes.ConceptEntriesByConceptIdAndCreatedAtQuery
>;
